<span *ngIf="dictionaryService.showInfoForReadOnlyStartDate()" class="read-only-banner">
  {{'general.system.read.only.mode.warning.info' | translate: [dictionaryService.getReadOnlyStartDate()]}}
</span>
<span *ngIf="dictionaryService.isReadOnlyModeActive()" class="read-only-banner">
  {{'general.system.read.only.mode.warning' | translate: [dictionaryService.getReadOnlyStartDate()]}}
</span>
<pcs-header [fullScreen]="fullScreen()">
  <pcs-main-menu></pcs-main-menu>
  <pcs-app-settings-menu [currentUser]="currentUser"
                 (showFullScreen)="fullScreenAction()"
                 [pcsDocumentationLink]="pcsDocumentationLink$ | async"
                 [mailPcsSupport]="mailPcsSupport$ | async"
                 [numberOfNotSeenFeatures]="numberOfNotSeenFeatures$ | async"
                 (logout)="onLogout()">
  </pcs-app-settings-menu>
</pcs-header>
<pcs-layout [fullScreen]="fullScreen()">
  <router-outlet></router-outlet>
</pcs-layout>
<pcs-footer></pcs-footer>
